import { EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS } from "../constants/ExlyEmptyState.constants";

export const isSeconadryCtaLearnMoreVariant = (
  variant?: keyof typeof EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS
) => variant === EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS.learn_more;

export const isSeconadryCtaPreviewImageVariant = (
  variant?: keyof typeof EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS
) => variant === EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS.preview_image;
